import { CampaignInfo, GetCampaignsResponse, GetVideoAdditionsResponse, VideoCreativesCollection } from './typings';

export function createCreativesCollection(response: GetVideoAdditionsResponse): VideoCreativesCollection {
    return {
        items: response.items.map(item => {
            return {
                id: item.id,
                thumbnail: item.screenshot_url,
                previewUrl: item.previewUrl,
                creativeId: item.creative_id,
                selected: false,
                editMode: false,
                name: item.name,
                nameInputValue: item.name,
                hasPackshot: item.has_packshot,
                shadowed: false,
                vast: item.vast
            };
        }),
        total: response.total,
        offset: response.new_offset
    };
}

export function createCampaignsList(response: GetCampaignsResponse, tld: string): CampaignInfo[] {
    return response.items.map(item => ({
        ...item,
        url: item.url.replace('%yandex_tld%', `yandex.${tld}`)
    }));
}
